import React from 'react';
import styles from './Footer.module.css';
const Footer = () => {
    return (React.createElement("footer", { className: styles.footer },
        React.createElement("p", null, "\u00A9 2026 Wolfeye Consulting. All rights reserved.")));
};
export default Footer;
